import { IMessagesState } from "./messages.types";

export const initialMessagesState: IMessagesState = {
  item: null,
  saveLoader: false,
  convertLoader: false,
  loader_with_message: {
    loading: false,
  },
};
